module.exports = __webpack_public_path__ + "static/media/Ramtin Attar.85840fd0.png";